import { Button } from "@material-ui/core";
import "./display-card-button.scss";
import { ChevronRight, Pageview } from "@material-ui/icons";

interface IDisplayCardButtonProps {
    isWarning: boolean;
    onClick: () => void;
    disabled?: boolean;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function DisplayCardButton(props: IDisplayCardButtonProps)
{
    return (
        <Button
            variant="contained"
            onClick={props.onClick}
            color="primary"
            className={_renderColorClassName(props.isWarning)}
            startIcon={<Pageview />}
            endIcon={<ChevronRight />}
            disabled={props.disabled}
        >
            Tovább
        </Button>
    );
}

/**
 * Meghatározza a gomb háttérszínét.
 * @param warningMessage Ha van, akkor warning kártya lesz látható.
 * @returns
 */
function _renderColorClassName(isWarning: boolean)
{
    return (isWarning ? "display-card-button warning-button" : "display-card-button");
}
